import React from "react";
import { baseURL } from "../apis";

export default function BannerPreview({ banner, className = "" }) {
  let imageSrc = "";
  if (banner?.image) {
    // Jika 'banner.image' adalah URL base64 dari file preview (dimulai dengan "data:"),
    // gunakan URL tersebut secara langsung.
    if (banner.image.startsWith("data:")) {
      imageSrc = banner.image;
    } else {
      // Jika tidak, anggap itu adalah path dari server dan gabungkan dengan baseURL.
      imageSrc = baseURL + banner.image;
    }
  }
  return (
    <div
      className={`relative overflow-hidden rounded-lg border border-gray-200 ${className}`}
    >
      <div className="bg-gray-50 p-4 border-b border-gray-200">
        <h3 className="text-sm font-medium text-gray-700">Banner Preview</h3>
      </div>

      {/* Gunakan variabel imageSrc yang sudah ditentukan */}
      {imageSrc ? (
        <div className="relative">
          <img
            src={imageSrc}
            alt={banner.title}
            className="w-full h-auto object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 hover:opacity-100 transition-opacity flex items-end">
            <div className="p-3 text-white w-full">
              <div className="font-medium">{banner.title}</div>
              <div className="text-xs">
                URL: {banner.targetUrl?.substring(0, 30)}
                {banner.targetUrl?.length > 30 ? "..." : ""}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="h-40 bg-gray-100 flex items-center justify-center">
          <span className="text-gray-400">No image selected</span>
        </div>
      )}
    </div>
  );
}
